/* ------------------------------------------------------------------------
   Product Page - Product Detail Labels
   ------------------------------------------------------------------------ */

document.addEventListener("DOMContentLoaded", function () {
  const descriptions = document.querySelectorAll(
    ".product-description-wrapper"
  );

  descriptions.forEach(function (description) {
    const paragraphs = description.querySelectorAll("p");

    paragraphs.forEach(function (paragraph) {
      const paragraphText = paragraph.textContent.trim();

      const match = paragraphText.match(
        /^(Materials?|Measurements?|Place of Origin)\s*:/i
      );

      if (!match) return;

      const labelText = match[1];

      const walker = document.createTreeWalker(
        paragraph,
        NodeFilter.SHOW_TEXT
      );

      const textNodes = [];

      while (walker.nextNode()) {
        textNodes.push(walker.currentNode);
      }

      let labelRemoved = false;
      let colonRemoved = false;

      textNodes.forEach(function (node) {
        if (!labelRemoved) {
          const labelRegex = new RegExp(
            "^\\s*" + labelText.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"),
            "i"
          );

          if (labelRegex.test(node.nodeValue)) {
            node.nodeValue = node.nodeValue.replace(
              labelRegex,
              ""
            );

            labelRemoved = true;
          }
        }

        if (labelRemoved && !colonRemoved) {
          if (/^\s*:/.test(node.nodeValue)) {
            node.nodeValue = node.nodeValue.replace(
              /^\s*:/,
              ""
            );

            colonRemoved = true;
          }
        }
      });

      const label = document.createElement("span");
      label.className = "product-detail-label";
      label.textContent = labelText + ":";

      paragraph.insertBefore(
        label,
        paragraph.firstChild
      );
    });
  });
});

/* ------------------------------------------------------------------------
   Product Page - Information Drawer Motion
   ------------------------------------------------------------------------ */

document.addEventListener("DOMContentLoaded", function () {
  const initializeAnimatedDetails = function (selector, groupSelector, groupItemSelector) {
    const drawers = document.querySelectorAll(selector);

    drawers.forEach(function (drawer) {
      const summary = drawer.querySelector("summary");

    if (!summary) return;

    summary.setAttribute("aria-expanded", drawer.open ? "true" : "false");

    let drawerAnimation = null;
    let drawerAnimationFrame = null;
    let closing = false;
    let expanding = false;

    const finishAnimation = function (open) {
      drawer.open = open;
      summary.setAttribute("aria-expanded", open ? "true" : "false");
      drawerAnimation = null;
      closing = false;
      expanding = false;
      drawerAnimationFrame = null;
      drawer.style.removeProperty("height");
      drawer.style.removeProperty("overflow");
    };

    const animateDrawer = function (open) {
      const startHeight = drawer.offsetHeight;

      if (drawerAnimation) drawerAnimation.cancel();
      if (drawerAnimationFrame) cancelAnimationFrame(drawerAnimationFrame);

      drawer.style.height = startHeight + "px";
      drawer.style.overflow = "hidden";

      if (open) {
        drawer.open = true;
        summary.setAttribute("aria-expanded", "true");
      } else {
        summary.setAttribute("aria-expanded", "false");
      }

      const endHeight = open ? drawer.scrollHeight : summary.offsetHeight;

      closing = !open;
      expanding = open;

      drawerAnimationFrame = requestAnimationFrame(function () {
        drawerAnimationFrame = null;
        drawerAnimation = drawer.animate(
          {
            height: [startHeight + "px", endHeight + "px"]
          },
          {
            duration: 400,
            easing: "ease-in-out",
            fill: "forwards"
          }
        );

        drawerAnimation.onfinish = function () {
          finishAnimation(open);
        };

        drawerAnimation.oncancel = function () {
          closing = false;
          expanding = false;
        };
      });
    };

    summary.addEventListener("click", function (event) {
      event.preventDefault();
      event.stopPropagation();

      const reduceMotion = window.matchMedia(
        "(prefers-reduced-motion: reduce)"
      ).matches;

      const opening = closing || (!drawer.open && !expanding);

      if (reduceMotion) {
        if (opening) {
          const drawerGroup = groupSelector && drawer.closest(groupSelector);

          if (drawerGroup) {
            drawerGroup.querySelectorAll(groupItemSelector).forEach(function (otherDrawer) {
              if (otherDrawer === drawer) return;

              otherDrawer.open = false;
              const otherSummary = otherDrawer.querySelector("summary");
              if (otherSummary) otherSummary.setAttribute("aria-expanded", "false");
            });
          }
        }

        finishAnimation(opening);
        return;
      }

      if (opening) {
        const drawerGroup = groupSelector && drawer.closest(groupSelector);

        if (drawerGroup) {
          drawerGroup
            .querySelectorAll(groupItemSelector + ' summary[aria-expanded="true"]')
            .forEach(function (otherSummary) {
              if (otherSummary !== summary) otherSummary.click();
            });
        }
      }

      animateDrawer(opening);
    });
    });
  };

  initializeAnimatedDetails(
    ".product-information-drawer details",
    ".product-information-drawers",
    ".product-information-drawer details"
  );
  initializeAnimatedDetails(
    ".accordion--faq-wrapper .accordion-content details",
    ".accordion-container",
    ".accordion-content details"
  );
});


/* ------------------------------------------------------------------------
   Silver Editorial - Disable CT, ET & ST Ligatures
   ------------------------------------------------------------------------ */

window.ATFixSilverEditorialLigatures = function (root) {
  const scope = root || document;

  if (!(scope instanceof Element) && scope !== document) return;

  const walker = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT, {
    acceptNode: function (node) {
      if (!/(ct|et|st)/i.test(node.nodeValue)) return NodeFilter.FILTER_REJECT;

      const parent = node.parentElement;

      if (
        !parent ||
        parent.closest("script, style, textarea, input, option, code, pre")
      ) {
        return NodeFilter.FILTER_REJECT;
      }

      const fontFamily = window
        .getComputedStyle(parent)
        .fontFamily
        .toLowerCase();

      return fontFamily.includes("silver editorial")
        ? NodeFilter.FILTER_ACCEPT
        : NodeFilter.FILTER_REJECT;
    }
  });

  const textNodes = [];

  while (walker.nextNode()) {
    textNodes.push(walker.currentNode);
  }

  textNodes.forEach(function (node) {
    node.nodeValue = node.nodeValue.replace(/(ct|et|st)/gi, function (match) {
      return match.charAt(0) + "\u200C" + match.charAt(1);
    });
  });
};

document.addEventListener("DOMContentLoaded", function () {
  window.ATFixSilverEditorialLigatures(document);
});

document.addEventListener("shopify:section:load", function (event) {
  window.ATFixSilverEditorialLigatures(event.target || document);
});

window.addEventListener("load", function () {
  window.ATFixSilverEditorialLigatures(document);
});

if (document.fonts && document.fonts.ready) {
  document.fonts.ready.then(function () {
    window.ATFixSilverEditorialLigatures(document);
  });
}

/* ------------------------------------------------------------------------
   Silver Editorial - Dash Spacing
   ------------------------------------------------------------------------ */

window.ATFixSilverEditorialDashes = function (root) {
  const scope = root || document;

  if (!(scope instanceof Element) && scope !== document) return;

  const textNodes = [];
  const walker = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT, {
    acceptNode: function (node) {
      if (!/[-–—]/.test(node.nodeValue)) return NodeFilter.FILTER_REJECT;

      const parent = node.parentElement;

      if (
        !parent ||
        parent.closest(
          "script, style, textarea, input, option, code, pre, .silver-editorial-dash"
        )
      ) {
        return NodeFilter.FILTER_REJECT;
      }

      const fontFamily = window
        .getComputedStyle(parent)
        .fontFamily
        .toLowerCase();

      return fontFamily.includes("silver editorial")
        ? NodeFilter.FILTER_ACCEPT
        : NodeFilter.FILTER_REJECT;
    }
  });

  while (walker.nextNode()) {
    textNodes.push(walker.currentNode);
  }

  textNodes.forEach(function (node) {
    const fragment = document.createDocumentFragment();

    node.nodeValue.split(/([-–—])/).forEach(function (part) {
      if (/^[-–—]$/.test(part)) {
        const dash = document.createElement("span");
        dash.className =
          "silver-editorial-dash" +
          (part === "-" ? " silver-editorial-dash--hyphen" : "");
        dash.textContent = part;
        fragment.appendChild(dash);
        return;
      }

      fragment.appendChild(document.createTextNode(part));
    });

    node.replaceWith(fragment);
  });
};

document.addEventListener("DOMContentLoaded", function () {
  window.ATFixSilverEditorialDashes(document);
});

document.addEventListener("shopify:section:load", function (event) {
  window.ATFixSilverEditorialDashes(event.target || document);
});

document.addEventListener("DOMContentLoaded", function () {
  const dashObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === Node.TEXT_NODE && node.parentElement) {
          window.ATFixSilverEditorialLigatures(node.parentElement);
          window.ATFixSilverEditorialDashes(node.parentElement);
          return;
        }

        if (node instanceof Element) {
          window.ATFixSilverEditorialLigatures(node);
          window.ATFixSilverEditorialDashes(node);
        }
      });
    });
  });

  dashObserver.observe(document.body, {
    childList: true,
    subtree: true
  });
});

/* ------------------------------------------------------------------------
   Customer-facing typography normalization
   Explicit em-dash punctuation is normalized before numeric/alphabetic
   ranges. Unspaced single en dashes are intentionally left alone because
   their meaning is ambiguous without editorial context (range vs. aside).
   ------------------------------------------------------------------------ */
(function () {
  var excluded = 'script, style, textarea, input, select, option, code, pre, kbd, samp, [contenteditable], .silver-editorial-dash';
  var normalizing = false;
  var number = '\\$?\\d+(?:\\.\\d+)?(?:\\/\\d+(?:\\.\\d+)?)?(?:mm|cm|ct|%)?';
  var numericRange = new RegExp('(' + number + ')\\s*-\\s*(' + number + ')', 'g');
  var upperRange = /\\b([A-Z])\\s*-\\s*([A-Z]+)\\b/g;
  var romanRange = /\\b([ivxlcdm]+)\\s*-\\s*([ivxlcdm]+)\\b/g;

  function normalizeText(value) {
    return value
      // Repeated hyphens and spaced en/em dashes are clearly punctuation.
      .replace(/\\s*(?:--+|—|–)\\s*/g, function (match) {
        return /--+/.test(match) || /\\s/.test(match) ? '—' : match;
      })
      // Only numeric/unit/currency and unambiguous alphabetic/roman ranges.
      .replace(numericRange, '$1–$2')
      .replace(upperRange, '$1–$2')
      .replace(romanRange, '$1–$2');
  }

  function eligible(node) {
    if (!node || !node.nodeValue || !/[-–—]/.test(node.nodeValue)) return false;
    var parent = node.parentElement;
    if (!parent || parent.closest(excluded)) return false;
    var style = window.getComputedStyle(parent);
    return style.display !== 'none' && style.visibility !== 'hidden';
  }

  window.normalizeTypography = function (root) {
    var scope = root || document;
    if (!(scope instanceof Element) && scope !== document) return;
    var nodes = [];
    var walker = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        return eligible(node) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
      }
    });
    while (walker.nextNode()) nodes.push(walker.currentNode);
    normalizing = true;
    try {
      nodes.forEach(function (node) {
        var normalized = normalizeText(node.nodeValue);
        if (normalized !== node.nodeValue) node.nodeValue = normalized;
      });
    } finally {
      normalizing = false;
    }
  };

  function initializeTypography() {
    window.normalizeTypography(document);
  }

  document.addEventListener('DOMContentLoaded', initializeTypography);
  document.addEventListener('shopify:section:load', function (event) {
    window.normalizeTypography(event.target || document);
  });
  document.addEventListener('DOMContentLoaded', function () {
    new MutationObserver(function (mutations) {
      if (normalizing) return;
      mutations.forEach(function (mutation) {
        if (mutation.type === 'characterData') window.normalizeTypography(mutation.target.parentElement);
        Array.prototype.forEach.call(mutation.addedNodes || [], function (node) {
          if (node.nodeType === Node.TEXT_NODE) window.normalizeTypography(node.parentElement);
          else if (node.nodeType === Node.ELEMENT_NODE) window.normalizeTypography(node);
        });
      });
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  });
}());

/* ------------------------------------------------------------------------
   Contact Form - Required Asterisks
   ------------------------------------------------------------------------ */

document.addEventListener("DOMContentLoaded", function () {
  const labels = document.querySelectorAll(
    ".section-contact-form .contact-form--form label"
  );

  labels.forEach(function (label) {
    if (!label.textContent.trim().startsWith("*")) return;

    label.innerHTML = label.innerHTML.replace(
      "*",
      '<span class="required-asterisk">*</span>'
    );
  });
});

/* ------------------------------------------------------------------------
   Blog-only Title Case and colon subtitles
   ------------------------------------------------------------------------ */
(function () {
  var minorWords = new Set(['a', 'an', 'the', 'and', 'but', 'or', 'nor', 'for', 'so', 'yet', 'as', 'at', 'by', 'from', 'in', 'into', 'of', 'on', 'onto', 'per', 'to', 'up', 'via', 'with']);
  var ordinaryAllCapsWords = new Set([
    'a', 'an', 'the', 'and', 'but', 'or', 'nor', 'for', 'so', 'yet', 'as', 'at', 'by', 'from', 'in', 'into', 'of', 'on', 'onto', 'per', 'to', 'up', 'via', 'with',
    'get', 'perfect', 'fit', 'ring', 'sizing', 'guide', 'time', 'jewelry', 'diamond', 'diamonds', 'gold', 'story', 'made'
  ]);

  function preserveWord(word) {
    var withoutPossessive = word.replace(/(?:['’][sS])$/, '');
    var normalized = withoutPossessive.toLowerCase();
    var isAmpersandInitialism = /^(?:[A-Z](?:&[A-Z])+)$/.test(withoutPossessive);
    var isNumberLetterTerm = /^\d+[A-Z]+$/.test(withoutPossessive);
    var isStylizedMixedCase = /[A-Z]/.test(withoutPossessive.slice(1)) && /[a-z]/.test(withoutPossessive);
    var isUppercaseAcronym = /^[A-Z]{2,5}$/.test(withoutPossessive) && !ordinaryAllCapsWords.has(normalized);

    return isAmpersandInitialism || isNumberLetterTerm || isStylizedMixedCase || isUppercaseAcronym;
  }

  function titleCase(text) {
    var words = text.trim().split(/(\s+)/);
    var wordIndexes = words.map(function (part, index) { return /\S/.test(part) ? index : null; }).filter(function (index) { return index !== null; });
    return words.map(function (part, index) {
      if (!/\S/.test(part)) return part;
      var edge = /^([^\p{L}\p{N}]*)(.*?)([^\p{L}\p{N}]*)$/u.exec(part);
      var prefix = edge[1], word = edge[2], suffix = edge[3];
      var previousWordIndex = wordIndexes[wordIndexes.indexOf(index) - 1];
      var followsColon = previousWordIndex !== undefined && /:$/.test(words[previousWordIndex]);
      var isFirstOrLast = index === wordIndexes[0] || index === wordIndexes[wordIndexes.length - 1] || followsColon;
      if (!word || preserveWord(word)) return part;
      var normalized = word.toLowerCase();
      if (!isFirstOrLast && minorWords.has(normalized)) return prefix + normalized + suffix;
      return prefix + normalized.charAt(0).toUpperCase() + normalized.slice(1) + suffix;
    }).join('');
  }

  window.ATBlogTitleCase = titleCase;

  function splitColon(element, className, titleCaseFullText) {
    if (element.querySelector('.' + className)) return;
    var text = element.textContent.trim();
    if (titleCaseFullText) text = titleCase(text);
    var colonIndex = text.indexOf(':');
    if (colonIndex === -1) {
      if (titleCaseFullText) element.textContent = text;
      return;
    }
    var before = text.slice(0, colonIndex + 1);
    var after = text.slice(colonIndex + 1).trim();
    if (!after) return;
    element.textContent = '';
    element.appendChild(document.createTextNode(before + ' '));
    var nested = document.createElement('span');
    nested.className = className;
    nested.textContent = titleCase(after);
    element.appendChild(nested);
  }

  function initializeBlogTitleCase(root) {
    var scope = root || document;
    Array.prototype.forEach.call(scope.querySelectorAll('#blog_posts .blog-title-wrapper h3 a'), function (element) {
      splitColon(element, 'blog-title-subtitle', false);
    });
    Array.prototype.forEach.call(scope.querySelectorAll('.main-blog-article .blog-article__title, .blog-article__body h1, .blog-article__body h2'), function (element) {
      splitColon(element, 'blog-colon-text', false);
    });
    Array.prototype.forEach.call(scope.querySelectorAll('.blog-article__body h3'), function (element) {
      splitColon(element, 'blog-colon-text', true);
    });
  }

  document.addEventListener('DOMContentLoaded', function () { initializeBlogTitleCase(document); });
  document.addEventListener('shopify:section:load', function (event) { initializeBlogTitleCase(event.target || document); });
}());

/* Adornment + Theory - Custom Section Classes */
(function () {
  function applyAtCustomClasses(root) {
    var scope = root || document;
    var markers = scope.querySelectorAll ? scope.querySelectorAll('[data-at-custom-class]') : [];

    markers.forEach(function (marker) {
      var section = marker.closest('.shopify-section');
      if (!section) return;

      var classes = (marker.getAttribute('data-at-custom-class') || '')
        .split(/\s+/)
        .filter(Boolean);

      classes.forEach(function (className) {
        section.classList.add(className);
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    applyAtCustomClasses(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    applyAtCustomClasses(event.target || document);
  });
})();


/* ==========================================================================
   BLOG ARTICLE
   ========================================================================== */

	/* ------------------------------------------------------------------------
	   Nested Colon Styling
	   ------------------------------------------------------------------------ */


/* ========================================================================
   INVENTORY BEHAVIOR
   ======================================================================== */

	(function () {
		function clearInStockDetails(productBox) {
			var heading = productBox.querySelector('[data-at-in-stock-heading]');
			var sizesElement = productBox.querySelector('[data-at-in-stock-sizes]');
			if (!heading || !sizesElement) return;

			heading.hidden = true;
			sizesElement.hidden = true;
			sizesElement.textContent = '';
		}

		function updateInStockDetails(productBox, inventoryData, selectedVariant) {
			var heading = productBox.querySelector('[data-at-in-stock-heading]');
			var sizesElement = productBox.querySelector('[data-at-in-stock-sizes]');
			var ringSizeIndex = inventoryData.physicalRingSizeOptionIndex;
			if (!heading || !sizesElement || typeof ringSizeIndex !== 'number' || ringSizeIndex < 0) return;

			// The selected variant supplies the active non-size configuration. Only
			// variants with a positive Shopify inventory quantity count as physical
			// stock; inventory policy is intentionally not considered here.
			var sizes = Object.keys(inventoryData.variants).map(function (variantId) {
				return inventoryData.variants[variantId];
			}).filter(function (candidate) {
				if (!candidate || candidate.quantity <= 0 || !candidate.options) return false;
				return candidate.options.every(function (optionValue, optionIndex) {
					return optionIndex === ringSizeIndex || optionValue === selectedVariant.options[optionIndex];
				});
			}).map(function (candidate) {
				return String(candidate.options[ringSizeIndex]);
			}).filter(function (size, index, allSizes) {
				return allSizes.indexOf(size) === index;
			}).sort(function (left, right) {
				var leftNumber = parseFloat(left);
				var rightNumber = parseFloat(right);
				if (!isNaN(leftNumber) && !isNaN(rightNumber) && leftNumber !== rightNumber) {
					return leftNumber - rightNumber;
				}
				return left.localeCompare(right, undefined, { numeric: true });
			});

			heading.hidden = sizes.length === 0;
			sizesElement.hidden = sizes.length === 0;
			sizesElement.textContent = sizes.length === 0 ? '' : (sizes.length === 1 ? 'Size ' : 'Sizes ') + sizes.join(', ');
		}

		function updateInventoryState() {
			document.querySelectorAll('#product-box').forEach(function (productBox) {
				var inventoryJson = productBox.querySelector('.inventory-state-json');
				var variantSelect = productBox.querySelector('.original-select');
				var ringSizeSelector = productBox.querySelector('[data-at-ring-size-selector]');
				var statusElements = productBox.querySelectorAll('[data-inventory-status]');
				var priorityBadges = productBox.querySelectorAll('[data-product-page-priority-badge]');
				var madeToOrderCopy = productBox.querySelectorAll('[data-made-to-order-copy]');
				var acceleratedCheckoutButtons = productBox.querySelectorAll('.shopify-payment-button');

				if (!inventoryJson || !variantSelect) return;

				var inventoryData;
				try {
					inventoryData = JSON.parse(inventoryJson.textContent);
				} catch (error) {
					console.error('Unable to read inventory state data.', error);
					return;
				}

				var variant = inventoryData.variants[String(variantSelect.value)];
			if (!variant) {
				clearInStockDetails(productBox);
				return;
			}
				updateInStockDetails(productBox, inventoryData, variant);
				// Exact-range MTO rings (for example, Rayo) are selectable to order,
				// but do not use the standard VL MTO badge/callout presentation.
				var isNonResizableRingSizeProduct = ringSizeSelector && inventoryData.resizable !== 'true';

				var state = 'in_stock';
				if (inventoryData.eligible === 'true') {
					state = variant.quantity > 0 ? 'ready_to_ship' : 'made_to_order';
				} else if (!variant.available) {
					state = 'sold_out';
				}

				productBox.dataset.inventoryState = state;

				var hasOtherMadeToOrderVariant = false;
				if (inventoryData.eligible === 'true') {
					hasOtherMadeToOrderVariant = Object.keys(inventoryData.variants).some(
						function (variantId) {
							return variantId !== String(variantSelect.value) &&
								inventoryData.variants[variantId].quantity <= 0;
						}
					);
				}

				statusElements.forEach(function (status) {
					status.classList.remove(
						'product-inventory-status--in_stock',
						'product-inventory-status--ready_to_ship',
						'product-inventory-status--made_to_order',
						'product-inventory-status--sold_out'
					);
					status.classList.add('product-inventory-status--' + state);
					status.hidden = state === 'in_stock';

					if (state === 'ready_to_ship') {
						status.textContent = inventoryData.labels.readyToShip;
					} else if (state === 'made_to_order') {
						status.textContent = inventoryData.labels.madeToOrder;
					} else if (state === 'sold_out') {
						status.textContent = inventoryData.labels.soldOut;
					} else {
						status.textContent = '';
					}
				});

				var badgeState = '';
				var badgeLabel = '';
				if (state === 'sold_out' && inventoryData.showSoldOut) {
					badgeState = 'sold_out';
					badgeLabel = inventoryData.labels.soldOut;
				} else if (variant.compareAtPrice > variant.price && inventoryData.showSale) {
					badgeState = 'sale';
					badgeLabel = inventoryData.labels.sale;
				} else if (state === 'ready_to_ship' && hasOtherMadeToOrderVariant) {
					badgeState = 'ready_to_ship';
					badgeLabel = inventoryData.labels.readyToShip;
				} else if (state === 'made_to_order') {
					badgeState = 'made_to_order';
					badgeLabel = inventoryData.labels.madeToOrder;
				} else if (inventoryData.customizable) {
					badgeState = 'customizable';
					badgeLabel = inventoryData.labels.customizable;
				}

				// Exact Ring Size products purchase a physical source variant for
				// Complimentary Resizing. That physical variant can be Size 7 and
				// in stock while the customer has requested Size 6, so its inventory
				// state must not leak into the customer-facing fulfillment badge.
				// A Ready to Ship badge therefore means an exact requested/physical
				// size match only.
				if (ringSizeSelector && ringSizeSelector.value) {
					var ringFulfillmentState = productBox.dataset.ringFulfillmentState;
					if (ringFulfillmentState === 'ready_to_ship') {
						badgeState = 'ready_to_ship';
						badgeLabel = inventoryData.labels.readyToShip;
					} else if (ringFulfillmentState === 'complimentary_resizing') {
						badgeState = '';
						badgeLabel = '';
					}
				}

				// The default variant is an inventory implementation detail for exact
				// Ring Size products. Do not expose a fulfillment badge before a
				// customer selects their requested Ring Size.
				if (ringSizeSelector && !ringSizeSelector.value &&
					(badgeState === 'ready_to_ship' || badgeState === 'made_to_order')) {
					badgeState = '';
					badgeLabel = '';
				}

				// Exact-range rings still use the regular Made to Order treatment for
				// offered sizes. Suppress it only when the selected size falls outside
				// that ring's approved range and switches to contact-us assistance.
				if (isNonResizableRingSizeProduct && ringFulfillmentState === 'contact_us' && badgeState === 'made_to_order') {
					badgeState = '';
					badgeLabel = '';
				}

				priorityBadges.forEach(function (badge) {
					badge.classList.remove(
						'sold-out-badge',
						'sale-badge',
						'ready-to-ship-badge',
						'made-to-order-badge',
						'customizable-badge'
					);
					badge.hidden = badgeState === '';
					badge.textContent = badgeLabel;
					if (badgeState) {
						badge.classList.add(badgeState.replace(/_/g, '-') + '-badge');
					}
				});

				madeToOrderCopy.forEach(function (message) {
					// Standard multi-variant products do not have the Ring Size selector.
					// Only Ring Size products defer this callout until a size is chosen.
					message.hidden = (!!ringSizeSelector && !ringSizeSelector.value) ||
						(isNonResizableRingSizeProduct && ringFulfillmentState === 'contact_us') ||
						state !== 'made_to_order';
				});

				acceleratedCheckoutButtons.forEach(function (paymentButton) {
					paymentButton.hidden = state === 'made_to_order';
				});
			});
		}

		document.addEventListener('DOMContentLoaded', updateInventoryState);
		document.addEventListener('change', function (event) {
			if (event.target.matches('.product-option-select select, .selector-wrapper select, .swatch input')) {
				window.setTimeout(updateInventoryState, 0);
			}
		});

		if (window.jQuery) {
			window.jQuery(document).on(
				'variantAvailable variantUnavailable',
				function () {
					window.setTimeout(updateInventoryState, 0);
				}
			);
		}
		})();


	/* ========================================================================
	   RING SIZE FULFILLMENT
	   Activates only for products explicitly marked custom.requires_ring_size.
	   Shopify variants remain the source of truth for physical inventory.
	   Canonical state is synchronized into form fields immediately before add.
	   ======================================================================== */

	(function () {
		// Products marked custom.hide_price retain their Shopify variants and
		// inventory, but must never submit through the storefront form. Liquid
		// omits the price and checkout controls; this capture-phase guard keeps
		// that override intact if another product script attempts a submission.
		document.addEventListener('submit', function (event) {
			if (event.target && event.target.closest && event.target.closest('[data-at-hide-price-product]')) {
				event.preventDefault();
				event.stopImmediatePropagation();
			}
		}, true);

		function truthy(value) {
			return value === true || value === 'true';
		}

		function numericSize(value) {
			var parsed = Number.parseFloat(value);
			return Number.isFinite(parsed) ? parsed : null;
		}

		function initializeRingSizeProduct(productBox) {
			if (productBox.dataset.atRingSizeInitialized === 'true') return;
			var inventoryJson = productBox.querySelector('.inventory-state-json');
			var form = productBox.querySelector('form[action*="/cart/add"]');
			var selector = productBox.querySelector('[data-at-ring-size-selector]');
			var variantSelect = productBox.querySelector('.original-select');
			var status = productBox.querySelector('[data-at-ring-size-status]');
			var purchaseButton = productBox.querySelector('#purchase');
			if (!inventoryJson || !form || !selector || !variantSelect || !status || !purchaseButton) return;
			var defaultPurchaseLabel = purchaseButton.textContent.trim();

			var data;
			try {
				data = JSON.parse(inventoryJson.textContent);
			} catch (error) {
				console.error('Unable to read Ring Size inventory data.', error);
				return;
			}
			if (!data.ringSizeProduct || data.ringSizeOptionIndex === null) return;
			productBox.dataset.atRingSizeInitialized = 'true';

			var ringIndex = Number(data.ringSizeOptionIndex);
			var stateStore = window.__atRingSizeState = window.__atRingSizeState || {};
			var ringState = stateStore[data.productId] || {
				requested: '',
				outcome: '',
				physicalVariantId: '',
				physicalSize: '',
				configuration: {}
			};
			stateStore[data.productId] = ringState;
			var isApplyingNativeVariant = false;

			function isTrackedInStock(variant) {
				return variant && variant.inventoryManagement && Number(variant.quantity) > 0;
			}

			function currentConfiguration() {
				var configuration = {};
				var selectedVariant = data.variants && data.variants[String(variantSelect.value)];
				(data.options || []).forEach(function (optionName, index) {
					if (index === ringIndex) return;
					var swatchControl = productBox.querySelector('.swatch input[name="option-' + index + '"]:checked');
					var optionControl = productBox.querySelector('#SingleOptionSelector-' + index);
					if (swatchControl && swatchControl.value) {
						configuration[optionName] = swatchControl.value;
					} else if (optionControl && optionControl.value) {
						configuration[optionName] = optionControl.value;
					} else if (selectedVariant && selectedVariant.options && selectedVariant.options[index]) {
						configuration[optionName] = selectedVariant.options[index];
					}
				});
				return configuration;
			}

			function matchesConfiguration(variant, configuration) {
				return Object.keys(configuration).every(function (optionName) {
					var index = data.options.indexOf(optionName);
					return index !== -1 && variant.options[index] === configuration[optionName];
				});
			}

			function variantById(id) {
				if (!id || !data.variants || !data.variants[String(id)]) return null;
				return Object.assign({ id: String(id) }, data.variants[String(id)]);
			}

			function findVariant(size, configuration) {
				return (data.variants ? Object.keys(data.variants) : []).map(variantById).find(function (variant) {
					return String(variant.options[ringIndex]) === String(size) && matchesConfiguration(variant, configuration);
				});
			}

			function findResizeCandidate(requestedSize, configuration) {
				return (data.variants ? Object.keys(data.variants) : []).map(variantById).filter(function (variant) {
					var physicalSize = numericSize(variant.options[ringIndex]);
					return isTrackedInStock(variant) && physicalSize !== null && matchesConfiguration(variant, configuration) && Math.abs(physicalSize - requestedSize) <= 2;
				}).sort(function (left, right) {
					var leftSize = numericSize(left.options[ringIndex]);
					var rightSize = numericSize(right.options[ringIndex]);
					var distance = Math.abs(leftSize - requestedSize) - Math.abs(rightSize - requestedSize);
					return distance || rightSize - leftSize;
				})[0] || null;
			}

			function chooseVariant(variant) {
				if (!variant) return;
				var sourceSwatch = Array.prototype.slice.call(productBox.querySelectorAll('.product-form-option--ring-size-source input')).find(function (input) {
					return String(input.value) === String(variant.options[ringIndex]);
				});
				isApplyingNativeVariant = true;
				if (sourceSwatch) {
					sourceSwatch.checked = true;
					sourceSwatch.dispatchEvent(new Event('change', { bubbles: true }));
				}
				var sourceControl = productBox.querySelector('#SingleOptionSelector-' + ringIndex);
				if (sourceControl) {
					sourceControl.value = variant.options[ringIndex];
					sourceControl.dispatchEvent(new Event('change', { bubbles: true }));
				}
				variantSelect.value = String(variant.id);
				variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
				isApplyingNativeVariant = false;
			}

			function currentPhysicalVariant() {
				return variantById(ringState.physicalVariantId);
			}

			function isComplete() {
				var physical = currentPhysicalVariant();
				if (!ringState.requested || !ringState.outcome || !ringState.configuration) return false;
				if (ringState.outcome === 'made_to_order') return !!findVariant(ringState.requested, ringState.configuration);
				return !!physical && !!ringState.physicalSize;
			}

			function setStatus(message) {
				productBox.dataset.ringFulfillmentState = ringState.outcome || '';
				status.hidden = !message;
				status.innerHTML = '';
				if (message) {
					var stateLabel = {
						ready_to_ship: 'Your Ring is Ready to Ship!',
						complimentary_resizing: 'Complimentary Resizing',
						made_to_order: 'Made to Order'
					}[ringState.outcome];
					if (stateLabel) {
						var title = document.createElement('strong');
						title.className = 'at-ring-size-status__title at-ring-size-status__title--' + ringState.outcome;
						title.textContent = stateLabel;
						status.appendChild(title);
					}
					if (ringState.outcome === 'complimentary_resizing') {
						[
							'Your size isn’t in stock, but we can make it happen! Complimentary resizing is included with your purchase.',
							'Ships in 10–15 business days.'
						].forEach(function (line, index) {
							var detail = document.createElement('span');
							detail.className = 'at-ring-size-status__detail' + (index === 1 ? ' at-ring-size-status__detail--shipping-window' : '');
							detail.textContent = line;
							status.appendChild(detail);
						});
					} else if (ringState.outcome === 'made_to_order') {
						['Your Ring Size: ' + ringState.requested, 'Ships in 6–8 weeks'].forEach(function (line) {
							var detail = document.createElement('span');
							detail.className = 'at-ring-size-status__detail';
							detail.textContent = line;
							status.appendChild(detail);
						});
					} else if (ringState.outcome === 'contact_us') {
						var contactDetail = document.createElement('span');
						contactDetail.className = 'at-ring-size-status__detail at-ring-size-status__detail--contact-us';
						contactDetail.appendChild(document.createTextNode('This ring is not currently available in your selected size. Contact us at '));
						var contactLink = document.createElement('a');
						contactLink.href = 'mailto:custom@adornmentandtheory.com';
						contactLink.textContent = 'custom@adornmentandtheory.com';
						contactDetail.appendChild(contactLink);
						contactDetail.appendChild(document.createTextNode(' for sizing assistance.'));
						status.appendChild(contactDetail);
					} else if (!stateLabel) {
						status.textContent = message;
					}
				}
				purchaseButton.disabled = !isComplete() || ringState.outcome === 'contact_us';
				purchaseButton.textContent = ringState.outcome === 'contact_us'
					? 'Unavailable'
					: (ringState.requested ? defaultPurchaseLabel : 'Select a Ring Size');
			}

			function setProperty(formElement, name, value, enabled) {
				var input = formElement.querySelector('[data-ring-property="' + name + '"]');
				if (!input) return;
				input.value = value || '';
				input.disabled = !enabled;
			}

			function syncForm() {
				var activeForm = productBox.querySelector('form[action*="/cart/add"]');
				if (!activeForm || !isComplete() || ringState.outcome === 'contact_us') {
					if (activeForm) {
						['requested-size', 'physical-size', 'fulfillment-state', 'resizing-required', 'source-variant-id', 'configuration'].forEach(function (name) {
							setProperty(activeForm, name, '', false);
						});
					}
					purchaseButton.disabled = true;
					return false;
				}

				var physical = currentPhysicalVariant();
				var submittedVariant = ringState.outcome === 'made_to_order' ? findVariant(ringState.requested, ringState.configuration) : physical;
				if (!submittedVariant) {
					return false;
				}
				chooseVariant(submittedVariant);
				setProperty(activeForm, 'requested-size', ringState.requested, true);
				setProperty(activeForm, 'physical-size', ringState.outcome === 'made_to_order' ? '' : ringState.physicalSize, ringState.outcome !== 'made_to_order');
				setProperty(activeForm, 'fulfillment-state', {
					ready_to_ship: 'Ready to Ship',
					complimentary_resizing: 'Complimentary Resizing',
					made_to_order: 'Made to Order'
				}[ringState.outcome], true);
				setProperty(activeForm, 'resizing-required', ringState.outcome === 'complimentary_resizing' ? 'Yes' : 'No', true);
				setProperty(activeForm, 'source-variant-id', ringState.outcome === 'made_to_order' ? '' : 'gid://shopify/ProductVariant/' + ringState.physicalVariantId, ringState.outcome !== 'made_to_order');
				setProperty(activeForm, 'configuration', JSON.stringify({ productId: data.productId, options: ringState.configuration }), true);
				purchaseButton.disabled = false;
				return true;
			}

			function applyOutcome(outcome, requested, source, configuration, selectedVariant) {
				ringState.requested = requested || '';
				ringState.outcome = outcome || '';
				ringState.configuration = configuration || {};
				ringState.physicalVariantId = source ? String(source.id) : '';
				ringState.physicalSize = source ? String(source.options[ringIndex]) : '';
				if (selectedVariant || source) chooseVariant(selectedVariant || source);
				if (!outcome) {
					setStatus('');
					return;
				}
				if (outcome === 'ready_to_ship') {
					setStatus('Ready to Ship');
				} else if (outcome === 'complimentary_resizing') {
					setStatus('Your Ring Size: ' + requested + '. Complimentary Resizing from our in-stock Size ' + source.options[ringIndex] + '. Ships in 10–15 business days.');
				} else if (outcome === 'made_to_order') {
					// The full existing Made-to-Order policy callout is shown directly
					// beneath Ring Size for this outcome; avoid a duplicate short status.
					setStatus('');
				} else {
					setStatus('Sizing assistance is available for this selection.');
				}
				syncForm();
			}

			function recalculate() {
				var requested = selector.value;
				var requestedNumber = numericSize(requested);
				if (!requested || requestedNumber === null) {
					applyOutcome(null);
					return;
				}
				var configuration = currentConfiguration();
				var exact = findVariant(requested, configuration);
				if (isTrackedInStock(exact)) {
					applyOutcome('ready_to_ship', requested, exact, configuration);
					return;
				}
				var resizeCandidate = truthy(data.resizable) ? findResizeCandidate(requestedNumber, configuration) : null;
				if (resizeCandidate && String(resizeCandidate.options[ringIndex]) !== String(requested)) {
					applyOutcome('complimentary_resizing', requested, resizeCandidate, configuration);
					return;
				}
				if (data.eligible === 'true' && exact) {
					applyOutcome('made_to_order', requested, null, configuration, exact);
					return;
				}
				applyOutcome('contact_us', requested, null, configuration);
			}

			selector.addEventListener('change', recalculate);
			(data.options || []).forEach(function (optionName, index) {
				if (index === ringIndex) return;
				var optionControl = productBox.querySelector('#SingleOptionSelector-' + index);
				if (optionControl) optionControl.addEventListener('change', recalculate);
			});
			productBox.addEventListener('change', function (event) {
				if (isApplyingNativeVariant || !event.target.matches('.swatch input')) return;
				recalculate();
			});
			form.addEventListener('submit', function (event) {
				if (!syncForm()) {
					event.preventDefault();
					event.stopImmediatePropagation();
					setStatus('Choose a valid Ring Size before adding this ring to your cart.');
				}
			}, true);
			purchaseButton.addEventListener('click', function (event) {
				if (!syncForm()) {
					event.preventDefault();
					event.stopImmediatePropagation();
					setStatus('Choose a valid Ring Size before adding this ring to your cart.');
				}
			}, true);
			productBox.addEventListener('at:ring-size-before-submit', function (event) {
				var synced = syncForm();
				if (!synced) event.preventDefault();
			});
			applyOutcome(null);

			var dialog = productBox.querySelector('[data-ring-size-confirmation-dialog]');
			if (dialog && window.HTMLDialogElement) {
				var cancel = dialog.querySelector('[data-ring-size-confirmation-cancel]');
				var confirm = dialog.querySelector('[data-ring-size-confirmation-confirm]');
				var dialogMessage = dialog.querySelector('[data-ring-size-confirmation-message]');
				var pendingButton = null;
				function closeDialog(afterClose) {
					if (!dialog.open) {
						if (afterClose) afterClose();
						return;
					}
					if (dialog.classList.contains('is-closing')) return;
					dialog.classList.add('is-closing');
					window.setTimeout(function () {
						dialog.classList.remove('is-closing');
						dialog.close();
						if (afterClose) afterClose();
					}, 400);
				}
				cancel.addEventListener('click', closeDialog);
				dialog.addEventListener('cancel', function (event) { event.preventDefault(); closeDialog(); });
				confirm.addEventListener('click', function () {
					if (!pendingButton) return;
					pendingButton.dataset.ringSizeConfirmationApproved = 'true';
					closeDialog(function () {
						pendingButton.click();
						window.setTimeout(function () { delete pendingButton.dataset.ringSizeConfirmationApproved; }, 0);
					});
				});
				document.addEventListener('click', function (event) {
					var button = event.target.closest('#purchase');
					if (!button || !productBox.contains(button) || button.dataset.ringSizeConfirmationApproved === 'true') return;
					if (ringState.outcome !== 'complimentary_resizing') return;
					event.preventDefault();
					event.stopImmediatePropagation();
					pendingButton = button;
						dialogMessage.innerHTML = '';
						var detail = document.createElement('span');
						detail.className = 'at-ring-size-confirmation__detail';
						detail.appendChild(document.createTextNode('You’ve selected '));
						var selectedSize = document.createElement('strong');
						selectedSize.textContent = 'Size ' + ringState.requested;
						detail.appendChild(selectedSize);
						detail.appendChild(document.createTextNode('. We’ll resize our in-stock Size ' + ringState.physicalSize + ' to get you the perfect fit.'));
						dialogMessage.appendChild(detail);
					if (!dialog.open) {
						dialog.showModal();
						dialog.focus({ preventScroll: true });
					}
				}, true);
			}
		}

		document.addEventListener('DOMContentLoaded', function () {
			document.querySelectorAll('[data-at-ring-size-product]').forEach(initializeRingSizeProduct);
		});
		document.addEventListener('shopify:section:load', function (event) {
			(event.target || document).querySelectorAll('[data-at-ring-size-product]').forEach(initializeRingSizeProduct);
		});
	})();

	/* ========================================================================
	   RING SIZE CART PREFLIGHT
	   Rechecks the accepted physical source immediately before normal checkout.
	   Made to Order lines deliberately do not consume or recheck physical stock.
	   ======================================================================== */

	(function () {
		function productHandleFromCartItem(item) {
			if (item.handle) return item.handle;
			var match = (item.url || '').match(/\/products\/([^/?]+)/);
			return match ? match[1] : null;
		}

		async function preflightRingLines() {
			var cartResponse = await fetch('/cart.js', { credentials: 'same-origin' });
			if (!cartResponse.ok) throw new Error('Unable to read the current cart.');
			var cart = await cartResponse.json();
			var restrictedLines = cart.items.filter(function (item) {
				return item.properties && item.properties['Fulfillment State'] && item.properties['Requested Final Size'];
			});
			var staleLines = [];

			await Promise.all(restrictedLines.map(async function (item) {
				if (item.quantity !== 1 || item.properties['Fulfillment State'] === 'Contact Us') {
					staleLines.push(item);
					return;
				}
				if (item.properties['Fulfillment State'] === 'Made to Order') return;
				var sourceId = item.properties['_at_ring_source_variant_id'];
				var handle = productHandleFromCartItem(item);
				if (!sourceId || !handle) {
					staleLines.push(item);
					return;
				}
				var productResponse = await fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' });
				if (!productResponse.ok) {
					staleLines.push(item);
					return;
				}
				var product = await productResponse.json();
				var sourceNumericId = String(sourceId).split('/').pop();
				var source = product.variants.find(function (variant) { return String(variant.id) === sourceNumericId; });
				if (!source || Number(source.inventory_quantity) < 1) staleLines.push(item);
			}));

			if (!staleLines.length) return true;
			await Promise.all(staleLines.map(function (item) {
				return fetch('/cart/change.js', {
					method: 'POST',
					credentials: 'same-origin',
					headers: { 'Content-Type': 'application/json' },
					body: JSON.stringify({ id: item.key, quantity: 0 })
				});
			}));
			var first = staleLines[0];
			var returnUrl = first.url || '/cart';
			window.alert('A selected ring size is no longer available. It has been removed from your cart so you can choose an updated option.');
			window.location.assign(returnUrl);
			return false;
		}

		document.addEventListener('submit', function (event) {
			var form = event.target;
			if (!form || form.id !== 'cartform' || !event.submitter || event.submitter.name !== 'checkout') return;
			if (form.dataset.atRingPreflightApproved === 'true') return;
			var submitter = event.submitter;
			event.preventDefault();
			preflightRingLines().then(function (approved) {
				if (!approved) return;
				form.dataset.atRingPreflightApproved = 'true';
				form.requestSubmit(submitter);
				window.setTimeout(function () { delete form.dataset.atRingPreflightApproved; }, 0);
			}).catch(function () {
				window.alert('We could not confirm current ring availability. Please try checkout again.');
			});
		}, true);
	})();


	/* ========================================================================
	   MADE TO ORDER: ADD-TO-CART CONFIRMATION
	   Uses the inventory state set by the inventory behavior controller above.
	   ======================================================================== */

	(function () {
		function getProductForm(button) {
			return button ? button.closest('form[action*="/cart/add"]') : null;
		}

		function requiresMadeToOrderConfirmation(form) {
			var productBox = form ? form.closest('#product-box') : null;
			return productBox && productBox.dataset.inventoryState === 'made_to_order';
		}

		function initializeMadeToOrderConfirmation() {
				document.querySelectorAll('[data-mto-confirmation-dialog]').forEach(function (dialog) {
				var productBox = dialog.closest('#product-box');
				var cancelButton = dialog.querySelector('[data-mto-confirmation-cancel]');
				var confirmButton = dialog.querySelector('[data-mto-confirmation-confirm]');
				var pendingPurchaseButton = null;
				var pendingConfirmedForm = null;

				if (!productBox || !cancelButton || !confirmButton || !window.HTMLDialogElement) return;

				if (window.jQuery) {
					window.jQuery(document).on('ajaxSend', function (event, xhr, settings) {
						if (!pendingConfirmedForm || !settings || !/\/cart\/add/.test(settings.url || '')) return;
						delete pendingConfirmedForm.dataset.atMtoConfirmedSubmission;
						pendingConfirmedForm = null;
					});
				}

				function closeDialog() {
					if (!dialog.open || dialog.classList.contains('is-closing')) return;
					dialog.classList.add('is-closing');
					window.setTimeout(function () {
						dialog.classList.remove('is-closing');
						dialog.close();
					}, 400);
				}

				function openDialog(button) {
					pendingPurchaseButton = button;
					dialog.classList.remove('is-closing');
					if (!dialog.open) {
						dialog.showModal();
						dialog.focus({ preventScroll: true });
					}
				}

				function returnFocus() {
					if (pendingPurchaseButton) pendingPurchaseButton.focus();
					pendingPurchaseButton = null;
				}

				cancelButton.addEventListener('click', closeDialog);
				dialog.addEventListener('cancel', function (event) {
					event.preventDefault();
					closeDialog();
				});
				dialog.addEventListener('close', returnFocus);

				confirmButton.addEventListener('click', function () {
					var button = pendingPurchaseButton;
					if (!button) return;
					var form = getProductForm(button);
					var beforeSubmit = new CustomEvent('at:ring-size-before-submit', {
						bubbles: true,
						cancelable: true
					});

					// Envy marks a zero-inventory MTO variant unavailable while the
					// canonical Ring Size sync selects it. The sync event is the
					// authoritative fail-closed check; do not abort the approved
					// submission because of that transient native button state.
					var syncAccepted = !!form && form.dispatchEvent(beforeSubmit);
					if (!syncAccepted) return;

					form.dataset.atMtoConfirmedSubmission = 'armed';
					pendingConfirmedForm = form;
					dialog.addEventListener('close', function resumeApprovedPurchase() {
						button.click();
					}, { once: true });
					closeDialog();
				});

				document.addEventListener('click', function (event) {
					var button = event.target.closest('#purchase');
					var form = getProductForm(button);
					if (!button || !form || !productBox.contains(form) || button.disabled) return;
					var bypassState = form.dataset.atMtoConfirmedSubmission;
					if (bypassState === 'armed') {
						form.dataset.atMtoConfirmedSubmission = 'native-click';
						return;
					}
					if (!requiresMadeToOrderConfirmation(form)) return;

					event.preventDefault();
					event.stopImmediatePropagation();
					openDialog(button);
				}, true);

				document.addEventListener('submit', function (event) {
					var form = event.target;
					if (!form.matches('form[action*="/cart/add"]') || !productBox.contains(form)) return;
					var bypassState = form.dataset.atMtoConfirmedSubmission;
					if (bypassState === 'armed' || bypassState === 'native-click') {
						form.dataset.atMtoConfirmedSubmission = 'form-submit';
						return;
					}
					if (!requiresMadeToOrderConfirmation(form)) return;

					event.preventDefault();
					openDialog(form.querySelector('#purchase'));
				}, true);
			});
		}

		document.addEventListener('DOMContentLoaded', initializeMadeToOrderConfirmation);
	})();


  /* ==========================================================================
   BRAND NAME FORMATTING
   ========================================================================== */

	document.addEventListener('DOMContentLoaded', function () {

		/* ------------------------------------------------------------------------
		   Text Replacement
		   ------------------------------------------------------------------------ */

			function formatBrandNames(root) {

				const walker = document.createTreeWalker(
					root,
					NodeFilter.SHOW_TEXT
				);

				const textNodes = [];

				while (walker.nextNode()) {
					textNodes.push(walker.currentNode);
				}


				textNodes.forEach(function (node) {

					/* Ignore Script + Style Content */

					const parent = node.parentElement;

					if (
						!parent ||
						parent.closest('script, style, textarea, input')
					) {
						return;
					}


					/* Replace Brand Name Variations */

					node.nodeValue = node.nodeValue
						.replace(/\bAdornment\s*\+\s*Theory\b/g, 'Adornment & Theory')
						.replace(/\bA\s*\+\s*T\b/g, 'A&T');
				});
			}


			formatBrandNames(document.body);
	});

  /* ==========================================================================
   TYPOGRAPHY PUNCTUATION
   ========================================================================== */

	document.addEventListener('DOMContentLoaded', function () {

		/* ------------------------------------------------------------------------
		   Typography Formatting
		   ------------------------------------------------------------------------ */

			function formatTypography(root) {

				const walker = document.createTreeWalker(
					root,
					NodeFilter.SHOW_TEXT
				);

				const textNodes = [];

				while (walker.nextNode()) {
					textNodes.push(walker.currentNode);
				}


				textNodes.forEach(function (node) {

					const parent = node.parentElement;

					if (
						!parent ||
						parent.closest(
							'script, style, textarea, input, select, option, code, pre'
						)
					) {
						return;
					}


					let text = node.nodeValue;


					/* ------------------------------------------------------------
					   Inch + Foot Marks
					   ------------------------------------------------------------ */

						/*
							12"     → 12″
							18"     → 18″
							6'      → 6′
							6' 2"   → 6′ 2″
						*/

						text = text.replace(
							/(\d+(?:[.,]\d+)?)"/g,
							'$1″'
						);

						text = text.replace(
							/(\d+(?:[.,]\d+)?)'/g,
							'$1′'
						);


					/* ------------------------------------------------------------
					   Apostrophes
					   ------------------------------------------------------------ */

						/*
							don't     → don’t
							artist's  → artist’s
							we're     → we’re
						*/

						text = text.replace(
							/([A-Za-z])'([A-Za-z])/g,
							'$1’$2'
						);


					/* ------------------------------------------------------------
					   Typographer Double Quotes
					   ------------------------------------------------------------ */

						/*
							"Text" → “Text”
						*/

						text = text.replace(
							/(^|[\s([{])"(?=\S)/g,
							'$1“'
						);

						text = text.replace(
							/"(?=$|[\s.,!?;:)\]}])/g,
							'”'
						);


					/* ------------------------------------------------------------
					   Typographer Single Quotes
					   ------------------------------------------------------------ */

						/*
							'Text' → ‘Text’
						*/

						text = text.replace(
							/(^|[\s([{])'(?=\S)/g,
							'$1‘'
						);

						text = text.replace(
							/'(?=$|[\s.,!?;:)\]}])/g,
							'’'
						);


					/* Apply Formatting */

						node.nodeValue = text;
				});
			}


			formatTypography(document.body);
	});
/* ========================================================================
   PRODUCT PAGE
   ======================================================================== */

/* ------------------------------------------------------------------------
   Standard Product Drawers
   Keep the single Details / Jewelry Care / Shipping drawer group directly
   beneath the gallery through tablet widths. On mobile, move that same DOM
   node after product-specific drawers so the information flow remains intact.
   ------------------------------------------------------------------------ */

(function () {
  var mobileQuery = window.matchMedia('(max-width: 767px)');

  function positionStandardDrawers(root) {
    var scope = root && root.querySelectorAll ? root : document;

    scope.querySelectorAll('#product-box').forEach(function (productBox) {
      var drawers = productBox.querySelector('.at-product-standard-drawers');
      var gallery = productBox.querySelector('.product-medias');
      var mobileAnchor = productBox.querySelector('[data-at-product-standard-drawers-mobile-anchor]');

      if (!drawers || !gallery || !mobileAnchor) return;

      if (mobileQuery.matches) {
        if (drawers.parentElement !== mobileAnchor) mobileAnchor.appendChild(drawers);
      } else if (drawers.parentElement !== gallery) {
        gallery.appendChild(drawers);
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    positionStandardDrawers(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    positionStandardDrawers(event.target);
  });

  if (mobileQuery.addEventListener) {
    mobileQuery.addEventListener('change', function () {
      positionStandardDrawers(document);
    });
  } else {
    mobileQuery.addListener(function () {
      positionStandardDrawers(document);
    });
  }
}());

/* ------------------------------------------------------------------------
   Filter Drawers
   Native details elements need a brief delayed close so Availability and
   Price can reverse the same soft fade-and-slide used by custom selects.
   ------------------------------------------------------------------------ */

(function () {
  var closeDuration = 260;

  function enhanceFilterDrawers(root) {
    var scope = root && root.querySelectorAll ? root : document;

    scope.querySelectorAll('.facets__disclosure').forEach(function (drawer) {
      if (drawer.dataset.atFilterAnimationInitialized === 'true') return;

      var summary = drawer.querySelector('summary');
      var display = drawer.querySelector('.facets__display');
      var pointerSelection = false;
      if (!summary || !display) return;

      drawer.dataset.atFilterAnimationInitialized = 'true';

      drawer.addEventListener('toggle', function () {
        if (drawer.open) {
          window.requestAnimationFrame(function () {
            if (drawer.open) display.classList.add('is-visible');
          });
        } else {
          display.classList.remove('is-visible');
          drawer.classList.remove('is-closing');
        }
      });

      summary.addEventListener('click', function (event) {
        if (!drawer.open || drawer.classList.contains('is-closing')) return;

        event.preventDefault();
        drawer.classList.add('is-closing');
        display.classList.remove('is-visible');

        window.setTimeout(function () {
          drawer.open = false;
        }, closeDuration);
      });

      // Match the shared custom-select behavior: a pointer-made choice should
      // not leave the Filter By drawer in a focused visual state until another
      // unrelated click. Keyboard users retain focus for continued navigation.
      drawer.addEventListener('pointerdown', function (event) {
        if (event.target.closest('input, select, button, a')) pointerSelection = true;
      });

      drawer.addEventListener('change', function () {
        if (!pointerSelection) return;
        pointerSelection = false;

        window.requestAnimationFrame(function () {
          if (document.activeElement && drawer.contains(document.activeElement)) {
            document.activeElement.blur();
          }
        });
      });

      if (drawer.open) {
        window.requestAnimationFrame(function () {
          if (drawer.open) display.classList.add('is-visible');
        });
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    enhanceFilterDrawers(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    enhanceFilterDrawers(event.target);
  });
}());

/* ========================================================================
   SEARCH
   ======================================================================== */

/* ------------------------------------------------------------------------
   Gemist Product Exclusion
   Keep Gemist's product records available to its own tool while excluding
   products tagged "gemist" from customer-facing predictive and full search.
   ------------------------------------------------------------------------ */

(function () {
  function customerSearchQuery(query) {
    var value = String(query || '').trim();
    return /(?:^|\s)-tag:gemist(?:\s|$)/i.test(value) ? value : value + ' -tag:gemist';
  }

  function enhancePredictiveSearch() {
    if (!window.wetheme || !window.wetheme.sectionsByType) return;

    var headers = window.wetheme.sectionsByType.get('header') || [];
    headers.forEach(function (header) {
      var predictiveSearch = header.predictiveSearch;
      if (!predictiveSearch || predictiveSearch.__atGemistSearchExclusion) return;

      predictiveSearch.__atGemistSearchExclusion = true;

      predictiveSearch.getSearchQuery = function () {
        return '/search/suggest.json?q=' + encodeURIComponent(customerSearchQuery(this.searchInput.value)) + '&resources[type]=product&resources[limit]=3&resources[limit_scope]=each';
      };

      predictiveSearch.getSearchPageUrlWithQuery = function () {
        return '/search?q=' + encodeURIComponent(String(this.searchInput.value || '').trim() + '* -tag:gemist') + '&type=product';
      };
    });
  }

  document.addEventListener('DOMContentLoaded', enhancePredictiveSearch);
  document.addEventListener('shopify:section:load', enhancePredictiveSearch);
}());

/* ========================================================================
   RING SIZE GUIDE MODAL
   ======================================================================== */

/* Open the sizing guide in its new tab while immediately beginning the
 * modal's existing fade-out transition in the current tab. */
document.addEventListener('click', function (event) {
  var guideLink = event.target.closest('.at-ring-size-help-modal__guide-link');
  if (!guideLink) return;

  var modal = guideLink.closest('envy-modal.at-ring-size-help-modal');
  if (modal && typeof modal.modalClose === 'function') {
    modal.modalClose();
  }
});

/* ========================================================================
   COLLECTIONS
   ======================================================================== */

/* ------------------------------------------------------------------------
   Gemist All-Collection Grid Continuity
   Ajaxinate appends each Load More result as a separate product grid. Since
   Gemist configuration records are intentionally omitted from the public
   All collection, merge later result grids into the original grid so their
   remaining product cards fill the preceding row instead of leaving gaps.
   ------------------------------------------------------------------------ */

(function () {
  var activeGemistLoadMoreSession = null;

  function customerVisibleCardCount(container) {
    return container.querySelectorAll(':scope > ol#template--collection > li').length;
  }

  function mergeGemistExcludedProductGrids(container) {
    var grids = container.querySelectorAll('ol#template--collection');
    if (grids.length < 2) return;

    var primaryGrid = grids[0];

    Array.prototype.slice.call(grids, 1).forEach(function (grid) {
      Array.prototype.slice.call(grid.children).forEach(function (card) {
        primaryGrid.appendChild(card);
      });

      grid.remove();
    });
  }

  function continueGemistExcludedLoadMore(container) {
    var session = activeGemistLoadMoreSession;

    if (!session || session.container !== container) return;

    var visibleCardsAdded = customerVisibleCardCount(container) - session.startCardCount;
    var nextLink = document.querySelector('#AjaxinateLoadMore a');

    if (visibleCardsAdded >= session.visiblePageSize || !nextLink || session.steps >= 10) {
      activeGemistLoadMoreSession = null;
      return;
    }

    session.steps += 1;

    window.setTimeout(function () {
      if (!nextLink.isConnected || activeGemistLoadMoreSession !== session) return;

      nextLink.dataset.atGemistAutomaticLoadMore = 'true';
      nextLink.click();
      delete nextLink.dataset.atGemistAutomaticLoadMore;
    }, 0);
  }

  function bindGemistExcludedCollection(container) {
    if (!container || container.dataset.atGemistGridMergeBound === 'true') return;

    container.dataset.atGemistGridMergeBound = 'true';
    mergeGemistExcludedProductGrids(container);

    new MutationObserver(function () {
      mergeGemistExcludedProductGrids(container);
      continueGemistExcludedLoadMore(container);
    }).observe(container, { childList: true, subtree: false });
  }

  function initializeGemistExcludedCollection() {
    bindGemistExcludedCollection(
      document.querySelector('#AjaxinateContainer[data-at-gemist-all-collection]')
    );
  }

  document.addEventListener('DOMContentLoaded', initializeGemistExcludedCollection);
  document.addEventListener('shopify:section:load', initializeGemistExcludedCollection);

  document.addEventListener('click', function (event) {
    var loadMoreLink = event.target.closest('#AjaxinateLoadMore a');
    var container = document.querySelector('#AjaxinateContainer[data-at-gemist-all-collection]');

    if (!loadMoreLink || !container || loadMoreLink.dataset.atGemistAutomaticLoadMore === 'true') return;

    activeGemistLoadMoreSession = {
      container: container,
      startCardCount: customerVisibleCardCount(container),
      visiblePageSize: Number(container.dataset.atGemistVisiblePageSize) || 12,
      steps: 0
    };
  }, true);

  new MutationObserver(initializeGemistExcludedCollection).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
}());
